module.exports = __webpack_public_path__ + "01e3d4e627655e3680145b12dd864d69.svg";